import React, { useEffect, useState } from "react";
import { SmartTextField } from "./SmartTextField";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { enqueueSnackbar } from "notistack";
import { useCreateLink } from "@seabrookstudios/pitch2table";
import { s2Url } from "@seabrookstudios/types";

const GameLinkNameTextField = ({ onChange }) => {
  return (
    <SmartTextField
      required
      label="Link Name"
      helperText="A descriptive name for this link (e.g., 'Scoring worksheet', 'BGG')"
      onChange={onChange}
    />
  );
};

const GameLinkUrlTextField = ({ onChange }) => {
  return <SmartTextField required label="URL" helperText="The web address for this link" onChange={onChange} />;
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {React.ReactNode} [props.CustomControl]
 */
export default function AddGameLinkFullScreenDialog({ gameId, CustomControl = undefined }) {
  const onSuccess = () => {
    enqueueSnackbar("Link added successfully", { variant: "success" });
  };

  const onError = () => {
    enqueueSnackbar("Failed to add link", { variant: "error" });
  };

  const createGameLink = useCreateLink(gameId, onSuccess, onError);

  const [name, setName] = useState("");
  const [url, setUrl] = useState(s2Url(""));
  const [canSave, setCanSave] = useState(false);

  const onSaveHandler = async () => {
    await createGameLink.mutateAsync({ name, url });
    setName("");
    setUrl(s2Url(""));
  };

  useEffect(() => {
    setCanSave(!!(name && url));
  }, [name, url]);

  return (
    <FullScreenDialog
      title="Add Link"
      actionText="save"
      onSaveHandler={onSaveHandler}
      canSave={!canSave}
      isBusy={createGameLink.isPending}
      CustomControl={CustomControl}
    >
      <GameLinkNameTextField onChange={setName} />
      <GameLinkUrlTextField onChange={setUrl} />
    </FullScreenDialog>
  );
}
